import PropTypes from "prop-types";
import { Col, Row } from "../../../atoms/DependencyHelper";
import LabelText from "../../../atoms/label/LabelText";
import { getUpdatedContactPerson } from "../../../../utils/helperServices";
import { journeyType } from "../../../../context/checkout-journey-context";
import { CREDIT_VETTING_STATUS } from "../../../../config/constants";
import { capitalizeFirstLetter } from "../../../../utils/helperServices";
import styles from "./PurchasedSectionInfo.module.scss";
import { Fragment } from "react";

const PurchasedSectionInfo = ({ heading, type, journey, orderData }) => {
  const SectionBlock = ({ titles, values }) => {
    return (
      <>
        <div className={styles["section-heading"]}>{heading}</div>
        <div className="d-none d-md-block">
          <Row noGutters={true} className={styles["container"]}>
            <Col md={5} lg={5} xl={5} className="d-flex flex-column">
              {titles.map((title, index) => (
                <LabelText className={styles["title"]} key={index}>
                  {title}:
                </LabelText>
              ))}
            </Col>
            <Col md={7} lg={7} xl={7} className="d-flex flex-column">
              {values.map((value, index) => (
                <LabelText className={styles["value"]} key={index}>
                  {value}
                </LabelText>
              ))}
            </Col>
          </Row>
        </div>

        <div className="d-block d-md-none">
          <Row noGutters={true} className={styles["container"]}>
            <Col xs={12} className="d-flex flex-column">
              {titles.map((title, index) => (
                <Fragment key={index}>
                  <LabelText className={styles["title"]}>{title}:</LabelText>
                  <LabelText className={styles["value"]}>
                    {values[index]}
                  </LabelText>
                </Fragment>
              ))}
            </Col>
          </Row>
        </div>
      </>
    );
  };

  function getCreditStatus(creditStatus) {
    if (creditStatus == CREDIT_VETTING_STATUS.offline) {
      return "Not checked yet";
    } else if (creditStatus) {
      return capitalizeFirstLetter(creditStatus);
    } else {
      return "-";
    }
  }

  return (
    <>
      {type == "order" && (
        <SectionBlock
          titles={
            journey == journeyType.upgrade
              ? ["Order / Tracking number", "Order type"]
              : ["Order / Tracking number", "Order type", "Credit status"]
          }
          values={
            journey == journeyType.upgrade
              ? [
                  orderData?.tracking_number ? orderData.tracking_number : "-",
                  orderData?.order_type ? orderData.order_type.join(", ") : "-",
                ]
              : [
                  orderData?.tracking_number ? orderData.tracking_number : "-",
                  orderData?.order_type ? orderData.order_type : "-",
                  orderData?.vetting_result
                    ? getCreditStatus(orderData?.vetting_result)
                    : "-",
                ]
          }
        />
      )}

      {type == "delivery" && (
        <SectionBlock
          titles={["Courier", "Delivery address", "Contact person"]}
          values={[
            orderData?.courier_partner ? orderData.courier_partner : "-",
            orderData?.delivery_address ? orderData.delivery_address : "-",
            orderData?.contact_person
              ? getUpdatedContactPerson(orderData.contact_person)
              : "-",
          ]}
        />
      )}
      {type == "store" && (
        <SectionBlock
          titles={["Store name & address","Collect by", "Contact person"]}
          values={[
            orderData?.delivery_address ? orderData.delivery_address : "-",
            orderData?.estimated_delivery_date ? orderData.estimated_delivery_date: "-",
            orderData?.contact_person
            ? getUpdatedContactPerson(orderData.contact_person)
            : "-",
          ]}
        />
      )}
    </>
  );
};

PurchasedSectionInfo.propTypes = {
  heading: PropTypes.string,
  type: PropTypes.string,
};

PurchasedSectionInfo.defaultProps = {
  heading: "Delivery details",
  type: "delivery",
  journey: "NEWLINE",
};

export default PurchasedSectionInfo;
